



























import Vue from 'vue';
import commonVuex from '../vuex/common';
import commonClient from '../apis';
import appClient from '../../../src/apis';
import moment from 'moment';
import { getCookie, setCookie} from '@/common/utils/Http';

export default Vue.extend({
  mixins: [commonVuex],
  props: {
    placement: {
      type: String,
      default: 'right-end',
    },
    popperClass: {
      type: String,
      default: 'trial-tips-box',
    },
  },
  data() {
    return {
      trialImg: require('assets/img/trial.svg'),
      moment,
      showBox: false,
      trialEndDay: null,
      isTrial: false,
      showP: true,
    };
  },
  watch: {
    'accountState.changeCrmLevelNum'() {
      if (!getCookie('trialTips')) {
        this.getCrmLevel();
      }
    },
  },
  methods: {
    toUpgrade() {
      window.location.href = '#/upgrade/buy';
      this.close();
    },
    close() {
      if (getCookie('trialTips')) {
        this.showBox = false;
      } else {
        setCookie('trialTips', 'true', 1);
        this.showBox = false;
      }
    },
    getTrial() {
      commonClient.getTime({}).success((r) => {
        const now = moment(moment(r).format('YYYY-MM-DD'));
        const crmCreate = moment(moment(this.account.crmCreate).format('YYYY-MM-DD'));
        const days = moment.duration(now.diff(crmCreate)).asDays();
        if (days > 3) {
          this.isTrial = false;
        } else {
          this.trialEndDay = 3 - days;
          this.isTrial = true;
          if (this.account.isVerified) {
            this.showBox = true;
          }
        }
      });
    },
    getCrmLevel() {
      appClient.getCrmLevel({}).success((r) => {
        if (!r.crmLevel) {
          this.getTrial();
        }
      })
    },
  },
  mounted() {
    if (!getCookie('trialTips') && !this.accountState.crmLevel) {
      this.getCrmLevel();
    }
  },
});

